module.exports = __webpack_public_path__ + "img/bgImg.43e65469.jpg";